exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.idCard[data-v-102905a4] {\n  height: 100%;\n  max-height: 100% !important;\n}\ncanvas[data-v-102905a4] {\n  max-height: 180px !important;\n  max-width: 320px;\n}\n", ""]);

// exports
